import React from "react"
import PropTypes from "prop-types"
import { navigate } from "gatsby"
import Link from "components/elements/link"
import "./addressCard.scss"

const AddressCard = ({
  address: { lat, lon },
  detailedAddress,
  enableDirectionsCTA,
  fax,
  image,
  name,
  phone,
  slug,
  viewMode,
}) => (
  <div
    className={`address-card ${viewMode === "list" ? "list-card" : "map-card"}`}
    id="locationCard"
  >
    {image && image.file ? (
      <div className="address-card-image-container">
        <img alt={image.alt || "Card image"} src={image.file.url} />
      </div>
    ) : (
      <div className="address-card-image-container placeholder" />
    )}

    <div className="content-container">
      {detailedAddress && (
        <div className="address-wrapper">
          {name && (
            <Link className="link headline" to={slug}>
              {name}
            </Link>
          )}
          <p className="address-info text" title={detailedAddress}>
            {detailedAddress.length > 80
              ? `${detailedAddress.slice(0, 80)}...`
              : detailedAddress}
          </p>
        </div>
      )}
      {phone && (
        <div className="phone">
          <div className="views-lable">Phone:</div>
          <a className="link custome d-inline-block" href={`tel:${phone}`}>
            {phone}
          </a>
        </div>
      )}
      {fax && (
        <div className="fax">
          <div className="views-lable">Fax:</div>
          <p className="custome">{fax}</p>
        </div>
      )}
      <div className="button-wrapper">
        <button
          className={`primaryButton py-2 px-3 ${
            viewMode !== "map" ? "shadow" : ""
          }`}
          onClick={() => navigate(slug)}
        >
          More Details
        </button>
      </div>
    </div>
  </div>
)

export const AddressCardProps = {
  address: PropTypes.shape({
    lat: PropTypes.number,
    lon: PropTypes.number,
  }),
  detailedAddress: PropTypes.string,
  fax: PropTypes.string,
  name: PropTypes.string,
  phone: PropTypes.string,
  slug: PropTypes.string,
}

AddressCard.propTypes = {
  ...AddressCardProps,
  enableDirectionsCTA: PropTypes.bool,
  viewMode: PropTypes.oneOf(["map", "list"]),
}

export default AddressCard
